import { createContext, ReactNode, useContext, useState } from 'react';
import { AgentTopic } from '../domain/models';

interface AgentContextShape {
  agents: AgentTopic[];
  activeAgent?: AgentTopic;
  setActiveAgentId: (id: string) => void;
}

const sampleAgents: AgentTopic[] = [
  { id: 'pto', name: 'PTO', systemPrompt: 'You are a PTO policy assistant.', description: 'Paid Time Off policies.' },
  { id: 'overtime', name: 'Overtime', systemPrompt: 'You are an overtime rules assistant.', description: 'Overtime calculations and compliance.' },
  { id: 'vacation', name: 'Vacation', systemPrompt: 'You help with vacation eligibility.', description: 'Vacation accrual and usage.' },
];

const AgentContext = createContext<AgentContextShape | undefined>(undefined);

export const AgentProvider = ({ children }: { children: ReactNode }) => {
  const [agents] = useState<AgentTopic[]>(sampleAgents);
  const [activeAgentId, setActiveAgentId] = useState<string>(sampleAgents[0].id);
  const activeAgent = agents.find((a) => a.id === activeAgentId);
  return <AgentContext.Provider value={{ agents, activeAgent, setActiveAgentId }}>{children}</AgentContext.Provider>;
  //return <></>
};

export const useAgents = () => {
  const ctx = useContext(AgentContext);
  if (!ctx) throw new Error('useAgents must be used within AgentProvider');
  return ctx;
};
